export class Province {
    public abbr: string;
    public name: string;
    constructor(abbr: string, name: string) {
        this.abbr = abbr;
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/classes/province.ts